import { TransportAppointmentAdminDto, AdminAppointmentInputDto } from '@dtos/transports/transport-appointment.dto';
import { withDevtools } from "@angular-architects/ngrx-toolkit";
import { computed, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TransportDto, TransportHistoryListItemDto, TransportHistoryListParamsDto, TransportAssignedListItemDto, TransportAssignedListParamsDto, PhaseEnum, TransportDocumentDto } from "@dtos/transports/transport.dto";
import { LegDocument } from "@dtos/transports/transports.dto.old";
import { patchState, signalStore, withComputed, withHooks, withMethods, withState } from "@ngrx/signals";
import { Helpers } from "@utils/helpers";
import { TransportProvider } from "../providers/transport.provider";
import { ConnectionType, TransportPrincipalType } from "@enums/transport.enum";
import { ClientStore } from "./clients.state";
import { AddressProvider } from "@providers2/address.provider";
import { BudgetDto, DriverDto, TransportAddress, TransportUnassignDriverDto, UnassignDriverPriceResponseDto, SurveyAnswerItemDto } from "@dtos/index";
import { TransportPhaseData } from "@dtos/transports/transport-phase-data";
import { QualityProvider } from "@providers2/quality.provider";
import { DriverStore } from "./drivers.state";
import { AdjustmentRangeOptionsDto, CancelTransportDto } from "@dtos/quality/cancel-transport.dto";
import { TransportDetailGetter } from "@dtos/transports/transport.get.dto";
import { MOCK_DEPARTURE_SURVEY, MOCK_ARRIVAL_SURVEY } from "../../pages/transports/components/survey/survey.mock";


export interface BillingItem {
  id: number;
  clientId: number;
  name: string;
  isFavorite: boolean;
}
export class PriceData {
  distance: number = 0;
  duration: number = 0;
  price: number = 0;
  base_total_price: number = 0;
  additional_services_price: number = 0;
  express_price: number = 0;
  stage_discount_price: number = 0;
  is_express: boolean = false;
  legs: any[] = [];
  
  get durationString() {
    const totalMinutes = Math.round(this.duration / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours} h ${minutes} min`;
  }
  static fromJson(data: any): PriceData {
    const p = new PriceData();
    p.distance = Number(data?.distance ?? data?.total_distance_km ?? 0);
    p.duration  = Number(data?.duration  ?? data?.total_duration_seconds ?? 0);
    p.price     = Number(data?.price     ?? data?.total_price ?? 0);
    p.base_total_price = Number(data?.base_total_price ?? 0);
    p.additional_services_price = Number(data?.additional_services_price ?? 0);
    p.express_price = Number(data?.express_price ?? 0);
    p.stage_discount_price = Number(data?.stage_discount_price ?? 0);
    p.is_express = Boolean(data?.is_express ?? false);
    p.legs = data?.legs ?? [];
    return p;
  }
}

export class TransportsState {
  history: TransportHistoryListItemDto[] = [];
  historyParams: TransportHistoryListParamsDto = { page: 1, page_size: 50 };
  historyTotalRecords: number = 0;
  historyPendingAppointmentsCount: number = 0;
  currentAppointment: TransportAppointmentAdminDto | null = null;
  isLoadingAppointment: boolean = false;
  assignedList: TransportAssignedListItemDto[] = [];
  assignedParams: TransportAssignedListParamsDto = { page: 1, page_size: 50, transport_status: 'PENDING' };
  assignedTotalRecords: number = 0;
  currentTransport: TransportDto | null = null;
  currentBilling: BillingItem | null = null;
  currentTransportId: number | null = null;
  currentTransportLoading: boolean = false;
  currentTransportError: string | null = null;
  curTransportDocuments: { required: LegDocument[], driver: LegDocument[], roadit: LegDocument[] } = { required: [], driver: [], roadit: [] };
  curTransportStartMision: TransportPhaseData | null = null;
  curTransportEndMision: TransportPhaseData | null = null;
  curTransportTransitMision: TransportPhaseData | null = null;
  curTransportDepartureSurvey: SurveyAnswerItemDto[] | null = null;
  curTransportArrivalSurvey: SurveyAnswerItemDto[] | null = null;
  currentTransportToCancel: CancelTransportDto | null = null;
  currentTransportClientId: number | null = null;
  prices: PriceData = new PriceData();
  adjustmentRangeOptions: AdjustmentRangeOptionsDto | null = null;
  curUnasigned: TransportUnassignDriverDto | null = null;
  curUnasingDriverPrices: UnassignDriverPriceResponseDto | null = null;
  transportFull: TransportDetailGetter | null = null;
  isEditing: boolean = false;
  priceError: string | null = null;
  stateView: 'edit' | 'create' | null = null;
  isChargin: boolean = false;
}


export const TransportStore = signalStore(
  {
    providedIn: 'root',

    // Configuración para Redux DevTools
    ...(typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION__ && {
      devtools: {
        name: 'RoadIt Transport Store',
        trace: true,
        traceLimit: 25
      }
    })
  },
  withDevtools('TransportStore'),
  // Estado inicial usando directamente GlobalStateData
  withState(() => loadTransportStoreFromStorage()),
  withComputed((store) => {
    const client = inject(ClientStore);
    return {
      clientId: computed<number>(() => {

        if(store.currentTransportClientId()) return store.currentTransportClientId()!;
        if(store.currentTransport() && store.currentTransport()!.legs && store.currentTransport()!.legs.length > 0 && store.currentTransport()!.legs[0].vehicles.length){
          return store.currentTransport()!.legs[0].vehicles[0].client!
        }
        return client.client().id!;
      })
    }
  }),
  withMethods((store) => {
    const provivder = inject(TransportProvider);
    const client = inject(ClientStore);
    return {
      getPrice: async () => {
        if(store.isChargin()) return;
        if(!store.currentTransport() || !store.currentTransport()!.legs.length ||!store.stateView()) return;
        try {

          var petition: { client_id: number, legs: any[] } = { client_id:  store.clientId(), legs: [] };
          var prices = new PriceData();

          let initiedPrice = false;
          try {
            for(let x = 0; x < (store.currentTransport()!.legs[0].vehicles.length ? store.currentTransport()!.legs[0].vehicles.length : 1); x++){
              petition.legs = store.currentTransport()!.legs.map(l => {
                return {
                  origin: l.origin_address.id,
                  destination: l.destination_address.id,
                  expected_departure_from: l.expected_departure_from,
                  vehicle: l.vehicles.length ? {
                    body_type: l.vehicles[x].body_type,
                    fuel_type: l.vehicles[x].fuel_type,
                  } : null,
                  additional_service_ids:l.vehicles.length && l.vehicles[x] && l.vehicles[x].additional_service_ids?.length ?  l.vehicles[x].additional_service_ids! : [],
                  connection_type: store.currentTransport()?.transport_principal_type === TransportPrincipalType.WITH_STOPOVER && x == 0 ?  ConnectionType.STOPOVER :  l.connection_type,
                }
              })  
            var res = await provivder.pricePreview(petition);
            if (res) {
              if(!initiedPrice){
                prices.distance = res.total_distance_km;
                prices.duration = res.total_duration_seconds;
                prices.price = Number(res.total_price);
                prices.base_total_price = Number(res.base_total_price);
                prices.additional_services_price = Number(res.additional_services_price);
                prices.express_price = Number(res.express_price);
                prices.stage_discount_price = Number(res.stage_discount_price);
                prices.is_express = res.is_express;
                prices.legs = res.legs.map((l:any) => { return { ...l, transport_id: l.transport_id ?? null } });
                initiedPrice = true;
              }else{
                prices.price += Number(res.total_price);
                prices.base_total_price += Number(res.base_total_price);
                prices.additional_services_price += Number(res.additional_services_price);
                prices.express_price += Number(res.express_price);
                prices.stage_discount_price += Number(res.stage_discount_price);
                prices.legs = prices.legs.concat(res.legs.map((l:any) => { return { ...l, transport_id: l.transport_id ?? null } }));
              }
            }
          }
          } catch (error) {
            console.error(error);
          }
          
          patchState(store, { prices: prices, priceError: null });

        } catch (error: any) {
          if(error.status === 412 && error.error.message){
            patchState(store, { priceError: error.error.message });
          }
          console.log(error);
        }
      },
    }
  }),
  // Método globales 
  withMethods((store) => {
    const client = inject(ClientStore);
    const route = inject(Router);
    return {
      updateState: (updates: Partial<TransportsState>) => {
        patchState(store, { ...updates });
        saveTransportStoreToStorage(store).then(() => {
          if(updates.currentTransport){
            store.getPrice();
        }});
        
      },
      initializeFromStorage: () => {
        var loadedStore = loadTransportStoreFromStorage();
        if (loadedStore) {
          patchState(store, loadedStore);
        }
        if (store.currentTransport() && store.currentTransport()?.billing_account && store.currentTransport()?.billing_account.billing_account_id !== 0 && client.client().id !== 0) {
          setTimeout(() => store.getPrice(), 1000);
        }
      },
      clearCurrentTransport: () => {
        patchState(store, {
          currentTransport: null,
          currentTransportId: null,
          currentTransportLoading: false,
          currentTransportError: null,
          curTransportDepartureSurvey: null,
          curTransportArrivalSurvey: null
        });
      },
      setStateView: (view: 'edit' | 'create' | null) => {
        patchState(store, { stateView: view });
      },
    }
  }),
  withMethods((store) => {
    const provivder = inject(TransportProvider);

        return {   
          loadTransportFull: async (transportId: number | string, hasManualPrice?: boolean, manualPrice?: number) => {
            const result = await provivder.getTransportFull(transportId);
            if (!result) {
              store.updateState({ transportFull: null });
              return;
            }
            if(hasManualPrice !== undefined) result.has_manual_price = hasManualPrice;
            if(manualPrice !== undefined) result.manual_price = manualPrice;
            store.updateState({ transportFull: TransportDetailGetter.fromJson(result) });
          },}
  }),


  withMethods((store) => {
    const provivder = inject(TransportProvider);
    const address = inject(AddressProvider);
    const client = inject(ClientStore);
    const driver = inject(DriverStore);
    const qualityProvider = inject(QualityProvider);
    return {
      loadHistory: async () => {
        const result = await provivder.loadHistory(store.historyParams());
        if (!result) {
          store.updateState({ history: [], historyTotalRecords: 0, historyPendingAppointmentsCount: 0 });
          return;
        }
        store.updateState({
          history: result.list,
          historyTotalRecords: result.totalRecords,
          historyPendingAppointmentsCount: result.pendingAppointmentsCount
        });
      },
      loadAssigned: async () => {
        const result = await provivder.loadAssigned(store.assignedParams());
        if (!result) {
          store.updateState({ assignedList: [] });
          return;
        }
        store.updateState({ assignedList: result.list, assignedTotalRecords: result.totalRecords });
      },
      loadTransport: async (transportId: number | string, withSummary: boolean = false, withDocs: boolean = false, driverId?: number) => {
        try {
          store.updateState({ isChargin: true });
          store.updateState({ currentTransportLoading: true, currentTransportError: null });
          const result = await provivder.getTransport(transportId);
          if (!result) {


            store.updateState({
              currentTransport: null,
              currentTransportId: null,
              currentTransportLoading: false,
              currentTransportError: 'TRANSPORT_NOT_FOUND'
            });
            store.updateState({ isChargin: false });
            store.getPrice();
            return;
          }
          await store.loadTransportFull(transportId, result.has_manual_price, result.manual_price);

          if((result.driver && result.driver.id) || driverId){
            driver.loadById(driverId!= undefined ? driverId : result.driver!.id!).then((driver) => {
            }).catch((error) => {
              console.error('Error al obtener el conductor:', error);
            });
            
          }else{
            driver.updateState({driver: new DriverDto()});
          }
          var addressIds: number[] = [];
          var swClient = false;
          var swDriver = false;
          
          for (var leg of result!.legs) {
            if (leg.origin_address && leg.origin_address.id && !addressIds.includes(leg.origin_address.id!)) addressIds.push(leg.origin_address.id!);
            if (leg.destination_address && leg.destination_address.id && !addressIds.includes(leg.destination_address.id!)) addressIds.push(leg.destination_address.id!);
            if (!swClient) {
              if (leg.vehicles && leg.vehicles.length > 0) {
                if (leg.vehicles[0].client) {
                  await client.loadById(leg.vehicles[0].client);
                  store.updateState({ currentTransportClientId: leg.vehicles[0].client });
                  swClient = true;
                }
              }
            }
          }
          var addresses = await address.getAddressesByIds(addressIds);
          let curAddress: TransportAddress | null | undefined = null;
          if (addresses && addresses.length > 0) {
            for (var leg of result!.legs) {
              if (leg.origin_address && leg.origin_address.id) {
                curAddress = addresses.find(a => a.id === leg.origin_address.id!);
                if (curAddress) {
                  leg.origin_address = curAddress;
                }
              }
              if (leg.destination_address && leg.destination_address.id) {
                curAddress = addresses.find(a => a.id === leg.destination_address.id!);
                if (curAddress) {
                  leg.destination_address = curAddress;
                }
              }
            }
          }
          const numericId = Number(transportId);
            const price = new PriceData();
            price.distance = parseFloat(store.stateView()  ? result.kilometers! : store.transportFull()?.kilometers!);
            price.duration = store.stateView()  ? result.duration! : store.transportFull()?.duration!;
            price.price = parseFloat(store.stateView()  ? result.price! : store.transportFull()?.price!);
            price.legs = result.legs;

          store.updateState({ currentTransport:TransportDto.fromJson({id: numericId, ...result}), currentTransportId: numericId, prices: price});
          if(withDocs){
            provivder.getTransportDocuments(numericId).then(docs => {
              if(docs){
                store.updateState({ curTransportDocuments: {
                    required: docs.required && Array.isArray(docs.required) ?  docs.required.map((d:any) => LegDocument.FromDto(d)) : [] ,
                    driver: docs.driver && Array.isArray(docs.driver) ?  docs.driver.map((d:any) => LegDocument.FromDto(d)) : [], 
                    roadit: docs.roadit && Array.isArray(docs.roadit) ? docs.roadit.map((d:any) => LegDocument.FromDto(d)) : []} });
              }
            });
          }
          if(withSummary){
            provivder.getTransportSummaryStart(numericId).then(summaryStart => {
              if(summaryStart){
                store.updateState({ curTransportStartMision: TransportPhaseData.fromDto(summaryStart) });
              }
            });
            provivder.getTransportSummaryEnd(numericId).then(summaryEnd => {
              if(summaryEnd){
                store.updateState({ curTransportEndMision: TransportPhaseData.fromDto(summaryEnd) });
              }
            });
            provivder.getTransportSummaryTransit(numericId).then(summaryTransit => {
              if(summaryTransit){
                store.updateState({ curTransportTransitMision: TransportPhaseData.fromDto(summaryTransit) });
              }
            });
            // TODO: Descomentar las llamadas al endpoint real el lunes cuando haya transportes con encuestas en BD:
            
            provivder.getSurveyAnswers(numericId, 'DEPARTURE').then(answers => {
              const dtos = (answers || []).map(a => SurveyAnswerItemDto.fromJson(a));
              store.updateState({ curTransportDepartureSurvey: dtos.length > 0 ? dtos : null });
            }).catch(() => {
              store.updateState({ curTransportDepartureSurvey: null });
            });
            provivder.getSurveyAnswers(numericId, 'ARRIVAL').then(answers => {
              const dtos = (answers || []).map(a => SurveyAnswerItemDto.fromJson(a));
              store.updateState({ curTransportArrivalSurvey: dtos.length > 0 ? dtos : null });
            }).catch(() => {
              store.updateState({ curTransportArrivalSurvey: null });
            });
            

            // DATOS MOCK TEMPORALES (Para pruebas visuales de las encuestas):
            /* store.updateState({
              curTransportDepartureSurvey: MOCK_DEPARTURE_SURVEY,
              curTransportArrivalSurvey: MOCK_ARRIVAL_SURVEY
            }); */
          }

          for(const l of result.legs) {
            for(const v of l.vehicles) {
              v.additional_services = client.additionalServices().filter(a => a.id && v.additional_service_ids.includes(a.id));
              if(v.additional_services.length ==0 && v.additional_service_ids.length!=0){
                v.additional_services = client.additionalServicesTemplates().filter(a => a.id && v.additional_service_ids.includes(a.id));
              }
            }
          }
          store.updateState({
            currentTransportLoading: false,
            currentTransportError: null,
            isChargin: false 
          });
          
//          store.getPrice();
        } catch (error) {
          console.error('Error al cargar transporte', error);
          store.updateState({
            currentTransport: null,
            currentTransportId: null,
            currentTransportLoading: false,
            currentTransportError: 'TRANSPORT_LOAD_ERROR',
            curTransportDocuments: { required: [], driver: [], roadit: [] },
            curTransportStartMision: null,
            curTransportEndMision: null,
            curTransportTransitMision: null,
            isChargin: false 
          });
          store.getPrice();
        }
      },
      saveTransportDocuments: async (file_template: File, phase: PhaseEnum) => {
        try {
          const result = await provivder.saveTransportDocuments(store.currentTransportId()!, file_template, phase, store.currentTransport()!.transport_principal_type);
           provivder.getTransportDocuments(store.currentTransportId()!).then(docs => {
              if(docs){
                store.updateState({ curTransportDocuments: {
                    required: docs.required && Array.isArray(docs.required) ?  docs.required.map((d:any) => LegDocument.FromDto(d)) : [] ,
                    driver: docs.driver && Array.isArray(docs.driver) ?  docs.driver.map((d:any) => LegDocument.FromDto(d)) : [], 
                    roadit: docs.roadit && Array.isArray(docs.roadit) ? docs.roadit.map((d:any) => LegDocument.FromDto(d)) : []} });
              }
            });
          return result;
        } catch (error) {
          console.error('Error al guardar documentos del transporte', error);
          return null;
        }
      },

      publishTransport: async () => {
        try {
          var transportToSend = store.currentTransport()!.toCreate();
          console.log(JSON.stringify(transportToSend, null, 2));
          if (transportToSend.transport_principal_type === TransportPrincipalType.WITH_STOPOVER) {
            var vehicles = [...transportToSend!.legs![0].vehicles!];
            transportToSend!.legs![1].vehicles = vehicles;
            transportToSend!.legs![0].connection_type = ConnectionType.STOPOVER;
          }
          if (transportToSend.legs!.length > 1) {
            transportToSend.legs![1].order = 2;
            delete (transportToSend.legs![1].connection_type);
          } else {
            delete (transportToSend.legs![0].connection_type);
          }
          delete transportToSend.has_manual_price;
          delete transportToSend.manual_price;
          const result = await provivder.publishTransport(transportToSend);
          return result;
        } catch (error) {
          console.error('Error al publicar transporte', error);
          throw error;
        }
      },
      updateTransport: async (id: number) => {
        try {
          var transportToSend = store.currentTransport()!.toCreate();
          if(store.transportFull()?.has_manual_price ){
            transportToSend.manual_price = Number(store.transportFull()?.manual_price);
            transportToSend.has_manual_price = true;
          }else{
            transportToSend.manual_price = 0;
            transportToSend.has_manual_price = false;
          }

          const result = await provivder.updateTransport(id, transportToSend);
          return result;
        } catch (error) {
          console.error('Error al actualizar transporte', error);
          throw error;
        }
      },
      getTransporUnasingDriverPrices: async (budget?: BudgetDto) => {
        try {
          const result = await provivder.getTransporUnasingDriverPrices(store.currentTransport()!.id!);
          if(budget){
            result.budget_amount = Number(budget.base_price);
            
          }
          store.updateState({ curUnasingDriverPrices: result  });
          return result;
        } catch (error) {
          console.error('Error al obtener precios de desasignación', error);
          return null;
        }
      },



      loadAppointment: async (transportId: number | string): Promise<TransportAppointmentAdminDto | null> => {
        store.updateState({ isLoadingAppointment: true });
        try {
          const data = await provivder.getAppointment(transportId);
          store.updateState({ currentAppointment: data, isLoadingAppointment: false });
          return data;
        } catch (error) {
          store.updateState({ isLoadingAppointment: false });
          return null;
        }
      },
      bookAppointment: async (transportId: number | string, data: AdminAppointmentInputDto) => {
        store.updateState({ isLoadingAppointment: true });
        const result = await provivder.bookAppointment(transportId, data);
        store.updateState({ isLoadingAppointment: false });
        if (result.success && result.data) {
          store.updateState({ currentAppointment: result.data });
        }
        return result;
      },
      updateAppointment: async (transportId: number | string, data: Partial<AdminAppointmentInputDto>) => {
        store.updateState({ isLoadingAppointment: true });
        const result = await provivder.updateAppointment(transportId, data);
        store.updateState({ isLoadingAppointment: false });
        if (result.success && result.data) {
          store.updateState({ currentAppointment: result.data });
        }
        return result;
      },
      resendAppointmentEmail: async (transportId: number | string) => {
        return await provivder.resendAppointmentEmail(transportId);
      },

      clearStore: () => {
        patchState(store, new TransportsState());
      },
    }
  }),

  withMethods((store) => {
    const provivder = inject(TransportProvider);
    return {
      getAdjustmentRangeOptions: async () => {
        try {
          const result = await provivder.getAdjustmentRangeOptions();
          patchState(store, { adjustmentRangeOptions: result });
          return result;
        } catch (error) {
          console.error('Error al obtener opciones de ajuste', error);
          return null;
        }
      },
      deleteTransport: async (transportId ?: number | string): Promise<boolean> => {
        try {
          await provivder.deleteTransport(transportId ?? store.currentTransport()!.id!);
          await store.loadHistory();
          await store.loadAssigned();
          return true;
        } catch (error: any) {
          throw  error;
        }
      },
      cancelTransport: async (transportId?: number | string): Promise<boolean> => {
        try {
          const cancelData = store.currentTransportToCancel();
          if (!cancelData) return false;
          
          await provivder.cancelTransport(transportId ?? store.currentTransport()!.id!, cancelData);
          await store.loadHistory(); // Recargar listas
          await store.loadAssigned();
          return true;
        } catch (error) {
          throw  error;
        }
      },
      updateCancelTransport: async (transportId?: number | string): Promise<boolean> => {
        try {
          const cancelData = store.currentTransportToCancel();
          if (!cancelData) return false;

          // Clonar y eliminar ID antes de enviar
          const dataToSend = new CancelTransportDto(cancelData);
          delete dataToSend.id;

          await provivder.updateCancelTransport(transportId ?? store.currentTransport()!.id!, dataToSend); // Usar updateCancelTransport del provider
          await store.loadHistory();
          await store.loadAssigned();
          return true;
        } catch (error) {
          throw error;
        }
      },
      getCancelTransport: async (transportId: number | string): Promise<void> => {
        try {
          const result = await provivder.getCancelTransport(transportId);
          if (result) {
            // Convertir Info -> DTO y asignar al state
            const dto = result.toCancelTransport();
            patchState(store, { currentTransportToCancel: dto });
          } else {
             patchState(store, { currentTransportToCancel: null });
          }
        } catch (error) {
          console.error('Error al obtener info de cancelación:', error);
          patchState(store, { currentTransportToCancel: null });
        }
      },
      unassignDriver: async (update: boolean = false): Promise<boolean> => {
        try {
          if(update){
            await provivder.updateUnassignDriver(store.curUnasigned()!);
          } else {
            await provivder.unassignDriver(store.curUnasigned()!);
          }
          return true;
        } catch (error) {
          throw error;
        }
      },
      getUnassignDriver: async (unassignId: number | string): Promise<void> => {
        try {
          const result = await provivder.getUnassignDriver(unassignId);
          if (result) {
            patchState(store, { curUnasigned: result });
          } else {
            throw new Error('No se encontro la informacion de desasignacion');
          }
        } catch (error) {
          console.error('Error al obtener info de desasignacion:', error);
          patchState(store, { curUnasigned: null });
          throw error;
        }
      },
    };
  }
  ),

  withMethods((store) => {
    const router = inject(Router);
    return {
      duplicateTransport: async (id: number) => {
        try {
          await store.loadTransport(id, false, false);

          if (store.currentTransport()) {
          const duplicated = store.currentTransport()!.duplicate(store.currentTransport()!);
          let index = 0;
          for(const leg of store.currentTransport()!.legs!){
            if(leg.documents_arrival){
              duplicated.legs[index].documents_arrival = [];
              for(const doc of leg.documents_arrival){
                duplicated.legs[index].documents_arrival!.push(new TransportDocumentDto({...doc}));
              }
            }
            
            if(leg.documents_departure){
              duplicated.legs[index].documents_departure = [];
              for(const doc of leg.documents_departure){
                duplicated.legs[index].documents_departure!.push(new TransportDocumentDto({...doc}));
              }
            }
            index++;
          }

            store.updateState({
              currentTransport: duplicated,
              currentTransportId: null
            });
          }
        } catch (error) {
          console.error('Error al duplicar transporte', error);
        }
      },
    }
  }),

/*   withHooks({
    onInit(store) {
      // Al arrancar el store (incluyendo recarga de página) se restaura el estado guardado
      store.initializeFromStorage();
    }
  }) */

);


async function saveTransportStoreToStorage(store: any, key = 'roadit_transport_store') {
  const result: Record<string, unknown> = {};

  // Función interna recursiva para detectar objetos File
  const processValue = async (val: any): Promise<any> => {
    // Si encontramos un File, lo convertimos usando el Helper
    if (val instanceof File) {
      return {
        _isStoredFile: true,
        name: val.name,
        data: await Helpers.fileToBase64(val)
      };
    }
    // Si es un array, procesamos cada elemento
    if (Array.isArray(val)) {
      return Promise.all(val.map(item => processValue(item)));
    }
    // Si es un objeto (y no una fecha), procesamos sus propiedades
    if (val !== null && typeof val === 'object' && !(val instanceof Date)) {
      const processedObj: any = {};
      for (const k in val) {
        processedObj[k] = await processValue(val[k]);
      }
      return processedObj;
    }
    return val;
  };

  // Recorremos las propiedades definidas en TransportsState
  for (const prop of Object.keys(new TransportsState())) {
    if (store[prop] !== undefined) {
      result[prop] = await processValue(store[prop]());
    }
  }
  
  Helpers.setSessionStorage(key, result);
}
function loadTransportStoreFromStorage(key = 'roadit_transport_store'): TransportsState {
  const st = new TransportsState();
  const data = Helpers.getSessionStorage<any>(key);
  
  if (data) {
    // Función interna recursiva para restaurar Files desde Base64
    const restoreValue = (val: any): any => {
      if (val && val._isStoredFile) {
        return Helpers.base64ToFile(val.data, val.name);
      }
      if (Array.isArray(val)) {
        return val.map(item => restoreValue(item));
      }
      if (val !== null && typeof val === 'object' && !(val instanceof Date)) {
        for (const k in val) {
          val[k] = restoreValue(val[k]);
        }
      }
      return val;
    };

    // Restauramos todos los posibles archivos en el objeto plano
    const restoredData = restoreValue(data);

    // Mapeamos a las clases DTO correspondientes (ahora con Files reconstruidos)
    st.currentTransport = restoredData.currentTransport ? TransportDto.fromJson(restoredData.currentTransport) : null;
    st.adjustmentRangeOptions = restoredData.adjustmentRangeOptions ? AdjustmentRangeOptionsDto.fromJson(restoredData.adjustmentRangeOptions) : null;
    st.assignedList = restoredData.assignedList ? (restoredData.assignedList as any[]).map((item: any) => TransportAssignedListItemDto.fromJson(item)) : [];
    st.history = restoredData.history ? restoredData.history.map((item: any) => TransportHistoryListItemDto.fromJson(item)) : [];
    st.assignedParams = restoredData.assignedParams ? restoredData.assignedParams : new TransportAssignedListParamsDto();
    st.assignedTotalRecords = restoredData.assignedTotalRecords ? restoredData.assignedTotalRecords : 0;
    st.curTransportDocuments = restoredData.curTransportDocuments ? {
      required: restoredData.curTransportDocuments.required.map((item: any) => LegDocument.FromDto(item)),
      driver: restoredData.curTransportDocuments.driver.map((item: any) => LegDocument.FromDto(item)),
      roadit: restoredData.curTransportDocuments.roadit.map((item: any) => LegDocument.FromDto(item))
    } : { required: [], driver: [], roadit: [] };
    st.curTransportEndMision = restoredData.curTransportEndMision ? TransportPhaseData.fromDto(restoredData.curTransportEndMision) : null;
    st.curTransportStartMision = restoredData.curTransportStartMision ? TransportPhaseData.fromDto(restoredData.curTransportStartMision) : null;
    st.currentTransportId = restoredData.currentTransportId ? restoredData.currentTransportId : null;
    st.currentTransportToCancel = restoredData.currentTransportToCancel ? CancelTransportDto.fromJson(restoredData.currentTransportToCancel) : null;
    st.curUnasigned = restoredData.curUnasigned ? TransportUnassignDriverDto.fromJson(restoredData.curUnasigned) : null;
    st.transportFull = restoredData.transportFull ? TransportDetailGetter.fromJson(restoredData.transportFull) : null;
    st.historyParams = restoredData.historyParams ? restoredData.historyParams : new TransportHistoryListParamsDto();
    st.historyTotalRecords = restoredData.historyTotalRecords ? restoredData.historyTotalRecords : 0;
    st.historyPendingAppointmentsCount = restoredData.historyPendingAppointmentsCount ? restoredData.historyPendingAppointmentsCount : 0;
    st.currentAppointment = restoredData.currentAppointment ? TransportAppointmentAdminDto.fromJson(restoredData.currentAppointment) : null;
    st.isLoadingAppointment = false;
    st.currentBilling = restoredData.currentBilling ? restoredData.currentBilling : null;
    st.currentTransportError = restoredData.currentTransportError ? restoredData.currentTransportError : null;
    st.curTransportTransitMision = restoredData.curTransportTransitMision ? TransportPhaseData.fromDto(restoredData.curTransportTransitMision) : null;
    st.curTransportDepartureSurvey = restoredData.curTransportDepartureSurvey && Array.isArray(restoredData.curTransportDepartureSurvey) ? restoredData.curTransportDepartureSurvey.map((i: any) => SurveyAnswerItemDto.fromJson(i)) : null;
    st.curTransportArrivalSurvey = restoredData.curTransportArrivalSurvey && Array.isArray(restoredData.curTransportArrivalSurvey) ? restoredData.curTransportArrivalSurvey.map((i: any) => SurveyAnswerItemDto.fromJson(i)) : null;
    st.prices = restoredData.prices ? PriceData.fromJson(restoredData.prices) : new PriceData();
    st.curUnasingDriverPrices = restoredData.curUnasingDriverPrices ? UnassignDriverPriceResponseDto.fromJson(restoredData.curUnasingDriverPrices) : null;
    st.isEditing = restoredData.isEditing ? restoredData.isEditing : false;
    st.currentTransportClientId = restoredData.currentTransportClientId ? restoredData.currentTransportClientId : null;
    st.currentTransportLoading = false;
  }
  return st;
}
/* 


function saveTransportStoreToStorage(store: any, key = 'roadit_transport_store') {
  const result: Record<string, unknown> = {};
  for (const prop of Object.keys(new TransportsState)) {
    if(store[prop] !== undefined){
      result[prop] = store[prop]();
    }
  }
  Helpers.setStorage(key, result);

}


function loadTransportStoreFromStorage(key = 'roadit_transport_store'): TransportsState {
  const st = new TransportsState();
  const data = Helpers.getStorage<TransportsState>(key);
  if(data){

    st.currentTransport = data.currentTransport ? TransportDto.fromJson(data.currentTransport) : null;
    st.adjustmentRangeOptions = data.adjustmentRangeOptions ? AdjustmentRangeOptionsDto.fromJson(data.adjustmentRangeOptions) : null;
    st.assignedList = data.assignedList ? (data.assignedList as any[])!.map((item: any) => TransportAssignedListItemDto.fromJson(item)) : [];
    st.history = data.history ? data.history.map((item: any) => TransportHistoryListItemDto.fromJson(item)) : [];
    st.assignedParams = data.assignedParams ? data.assignedParams : new TransportAssignedListParamsDto();
    st.assignedTotalRecords = data.assignedTotalRecords ? data.assignedTotalRecords : 0;
    st.curTransportDocuments = data.curTransportDocuments ? {required: data.curTransportDocuments.required.map((item: any) => LegDocument.FromDto(item)), driver: data.curTransportDocuments.driver.map((item: any) => LegDocument.FromDto(item)), roadit: data.curTransportDocuments.roadit.map((item: any) => LegDocument.FromDto(item))} : {required: [], driver: [], roadit: []};
    st.curTransportEndMision = data.curTransportEndMision ? TransportPhaseData.fromDto(data.curTransportEndMision) : null;
    st.curTransportStartMision = data.curTransportStartMision ? TransportPhaseData.fromDto(data.curTransportStartMision) : null;
    st.currentTransportId = data.currentTransportId ? data.currentTransportId : null;
    st.currentTransportToCancel = data.currentTransportToCancel ? CancelTransportDto.fromJson(data.currentTransportToCancel) : null;
    st.curUnasigned = data.curUnasigned ? TransportUnassignDriverDto.fromJson(data.curUnasigned) : null;
    st.transportFull = data.transportFull ? TransportDetailGetter.fromJson(data.transportFull) : null;
    st.historyParams = data.historyParams ? data.historyParams : new TransportHistoryListParamsDto();
    st.historyTotalRecords = data.historyTotalRecords ? data.historyTotalRecords : 0;     
    st.currentBilling = data.currentBilling ? data.currentBilling : null;
    st.currentTransportError = data.currentTransportError ? data.currentTransportError : null;
    st.curTransportTransitMision = data.curTransportTransitMision ? TransportPhaseData.fromDto(data.curTransportTransitMision) : null;
    st.prices = data.prices ? PriceData.fromJson(data.prices) : new PriceData();
    st.curUnasingDriverPrices = data.curUnasingDriverPrices ? UnassignDriverPriceResponseDto.fromJson(data.curUnasingDriverPrices) : null;
    st.isEditing = data.isEditing ? data.isEditing : false;
    st.currentTransportClientId = data.currentTransportClientId ? data.currentTransportClientId : null;
    st.currentTransportLoading = false;

  }
  return st;
} */